import { FormattedMessage } from 'react-intl';

import { commonMessages } from '@/messages/common';

export const Deposit = <FormattedMessage {...commonMessages.deposit} />;

export const PreOrderNote = (
  <FormattedMessage
    defaultMessage='You will receive an e-mail once the watch is available to pay the balance.'
    id='shoppingBag.preOrderNote'
  />
);
